import React from "react";
import serviceUnavailable from "../assets/error-screens/pam_no_data_found.svg";
import { useTranslation } from "react-i18next";
import "./no_data_found.css";
import { Icon } from "pepsico-ds";
import { useNavigate } from "react-router-dom";

const PamNoDataApproval = ({supportMail = "myPAMEngineering@pepsico.com"}) => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    return (
        <div className="no-data-found-container d-flex justify-content-center m-auto">
            <div className="no-data-found-content">
                <div className="w-100"><img src={serviceUnavailable} alt="Access required" className="mx-auto d-block" /></div>
                <div className="no-data-found-main-heading">{t('No Pending Approvals Found')}</div>
                <div className="no-data-found-sub-heading">{t("There are no approvals pending currently.")}</div>
                <div className="d-flex justify-content-center" style={{gap: '10px'}}>
                    <button className="request-button" style={{width: 'auto', padding: "8px 24px", fontWeight: '700'}} onClick={() => navigate('/home')}>
                        <Icon
                        alt="alt value"
                        icon="arrow_backword"
                        size="medium"
                        style={{ marginRight: '4px', width: '20px' }}
                        />
                        <span>{t('auditRequest.back_to_Home')}</span>
                    </button>
                    <button className="my-request-button" style={{marginTop: '24px', marginBottom: '16px', width: 'auto', fontWeight: '700', padding: "8px 24px"}} onClick={() => window.location.href = `mailto:${supportMail}`}>
                        <span>{t('auditRequest.contact_support')}</span>
                    </button>
                </div>
            </div>
        </div>
    );
};
export default PamNoDataApproval;